"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.ContextMenu = void 0;
var _contextMenu = require("./contextMenu");
exports.PLUGIN_KEY = _contextMenu.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _contextMenu.PLUGIN_PRIORITY;
exports.ContextMenu = _contextMenu.ContextMenu;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/contextMenu/index.js
// module id = 1291
// module chunks = 0